/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: webapp-contrib
 * Version: 7.1.2
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
(function ($) {
    var $td = $('.roles_table td'),
        $checkboxes = $('.roles_table td input[type="checkbox"]:not([data-check="all"])'),
        $checkAll = $('.roles_table td input[type="checkbox"][data-check="all"]');

    $checkboxes.click(function (e) {
        e.bubbles = false;
        var checkAll = (($(this).closest('tr').find('input[type="checkbox"]').length - 1) - $(this).closest('tr').find('input[type="checkbox"]:checked:not([data-check])').length) == 0;

        $(this).prop('checked', !$(this).prop('checked'));
        $(this).closest('tr').find('input[type="checkbox"][data-check="all"]').prop('checked', checkAll);
    });

    $checkAll.click(function () {
        var $rowChecks = $(this).closest('tr').find('input[type="checkbox"]:not([data-check])');
        $(this).prop('checked', !$(this).prop('checked'));

        $rowChecks.prop('checked', !$(this).prop('checked'));
    });

    $td.click(function () {
        var $checkAll = $(this).find('input[type="checkbox"][data-check="all"]');

        if ($checkAll.length > 0) {
            var $rowChecks = $(this).closest('tr').find('input[type="checkbox"]:not([data-check])');
            $rowChecks.prop('checked', !$checkAll.prop('checked'));
            $checkAll.prop('checked', !$checkAll.prop('checked'));
        } else {
            var $checkbox = $(this).find('input[type="checkbox"]');
            $checkbox.prop('checked', !$checkbox.prop('checked'));

            var checkAll = (($(this).closest('tr').find('input[type="checkbox"]').length - 1) - $(this).closest('tr').find('input[type="checkbox"]:checked:not([data-check])').length) == 0;
            $(this).closest('tr').find('input[type="checkbox"][data-check="all"]').prop('checked', checkAll);
        }
    });

})(jQuery.noConflict());